module.exports = __webpack_public_path__ + "img/chnl-lft-bg.e6b8a09b.svg";